/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Meta, Meta$inboundSchema } from "./meta.js";
import {
  V1LivenessResponseData,
  V1LivenessResponseData$inboundSchema,
} from "./v1livenessresponsedata.js";

export type V1LivenessResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  /**
   * Response data for the liveness check endpoint. This provides a simple indication of whether the Teral API service is running and able to process requests. Monitoring systems can use this endpoint to track service availability and trigger alerts if the service becomes unhealthy.
   */
  data: V1LivenessResponseData;
};

/** @internal */
export const V1LivenessResponseBody$inboundSchema: z.ZodType<
  V1LivenessResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: V1LivenessResponseData$inboundSchema,
});

export function v1LivenessResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V1LivenessResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1LivenessResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1LivenessResponseBody' from JSON`,
  );
}
